/*
	© 2017 NetSuite Inc.
	User may not copy, modify, distribute, or re-bundle or otherwise make available this code;
	provided, however, if you are an authorized user with a NetSuite account or log-in, you
	may use this code subject to the terms that govern your access and use.
*/

//@module MenuTree
define('MenuTree.Node.View'
,	[
		'Backbone.CompositeView'
	,	'Backbone.CollectionView'

	,	'menu_tree_node.tpl'
	,	'Backbone'

	]
,	function(

		BackboneCompositeView
	,	BackboneCollectionView

	,	menu_tree_node_tpl
	
	,	Backbone
	)
{
	'use strict';
	//@class MenuTree.Node.View @extends Backbone.View
	var MenuTreeNodeView = Backbone.View.extend({

		//@propery {Function} template
		template: menu_tree_node_tpl

		//@method initialize
	,	initialize: function (options)
		{	
			this.node = options.model;
			this.level = options.level;
			BackboneCompositeView.add(this);
		}

		//@propery {Object} childViews
	,	childViews: {
			'MenuItems.Collection': function ()
			{
				return new BackboneCollectionView(
				{		
						collection: this.node.get('children')
					,	childView: MenuTreeNodeView
					,	viewsPerRow: 1
					,	childViewOptions: {
							level: this.level + 1
						}
				});
			}
		}

		//@method getContext @returns MenuTree.Node.View.Context
	,	getContext: function()
		{
			if(this.model.get('name') && this.node.get('name'))
			{	
				//if(	this.model.get('name').search('Favorites') !== -1 && this.node.get('name').search('Favorites') !== -1 )
				if(	this.model.get('name') && this.node.get('name'))
				{
					var prevUrl = this.model.get('url')
					,	internalid,newUrl;
					
					if( prevUrl.search('wishlist') !== -1 && prevUrl.match(/\d/g))
					{
						internalid = prevUrl.match(/\d/g).join('');
						newUrl = '/Favorites/'+internalid;
						this.model.set('url',newUrl,{silent:true});
						this.node.set('url',newUrl,{silent:true});
						this.node.set('isFavorites',true,{silent:true});
					}
				}	
			}
			// @class MenuTree.Node.View.Context
			return {
					//@propery {Model} node
					node: this.node
					//@propery {Number} level
				,	level: this.level
			};
		}

	});

	return MenuTreeNodeView;
});
